import React from "react";
import { FaEnvelopeOpenText } from "react-icons/fa";

const Messages = () => {
  return (
    <div className="container-fluid py-4">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8">
          <div className="card border-0">
            <div className="card-body text-center py-5">
              <FaEnvelopeOpenText
                size={48}
                className="mb-3"
                style={{ color: "var(--brand-500, #B9D542)" }}
              />
              <h4 className="mb-2">No Messages Yet</h4>
              <p className="text-muted mb-0">
                Your inbox is empty. Once internal messaging is set up, staff
                messages will show up here.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Messages;
